/**
 * 1品ごとの運送料の保証金額を自動設定するための条件群です。
 * 基本的にパターンコードが設定されていなかった場合、補償対象外となります。
 * intellisenseで具体的な数字を表示したい場合は、こちらを使わずに as const を変数に付与してください
 */
export interface 運送料保証条件 {
  荷主コード: string
  表紙: {
    [表紙名: string]: {
      コード: string
      パターンコード: string
      品コード: string
      保障数量: number
      保障金額: number
      保障単価?: number
    }
  }
}

// 昭和産業トン数保障計算用定数
export const 昭和産業 = {
  荷主コード: "32140",
  表紙: {
    ジャーム: {
      コード: "1",
      パターンコード: "5000",
      品コード: "32720",
      保障数量: 10, //トン数
      保障金額: 11550,
    },
    ジャーム粕: {
      コード: "2",
      パターンコード: "5010",
      品コード: "93273",
      保障数量: 8, //トン数
      保障金額: 23120,
    },
  },
} as const

const unsoryoHosyo = {
  昭和産業,
}

export default unsoryoHosyo
